import { Link } from "react-router-dom";
import { newsArticles } from "@/mocks/news";

const sorted = [...newsArticles].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
const feature = sorted[0];
const list = sorted.slice(1, 6);

export default function NewsPreview() {
  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <Link
        to={`/news/${feature.id}`}
        className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-50"
      >
        <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200">
          <img
            src={feature.cover}
            alt={`${feature.title} 配图`}
            title={`${feature.title} - 芒果tv 娱乐资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            头条
          </span>
        </div>
        <div className="p-4">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded bg-accent-100 px-1.5 py-0.5 font-medium text-accent-700">
              {feature.category}
            </span>
            <span>{feature.publishedAt}</span>
            <span>· {feature.source}</span>
          </div>
          <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
            {feature.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
            {feature.summary}
          </p>
        </div>
      </Link>

      <div className="flex flex-col gap-3">
        {list.map((a) => (
          <Link
            key={a.id}
            to={`/news/${a.id}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-16 md:w-28">
              <img
                src={a.cover}
                alt={`${a.title} 配图`}
                title={`${a.title} - 芒果tv 娱乐资讯`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600">
                {a.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {a.category} · {a.publishedAt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}